var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCustomTheme = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1.92604 14.3373C2.64354 15.0518 3.58524 15.0607 4.29377 14.3551C4.8274 13.8314 5.33861 12.6731 5.73772 12.0517L6.77808 13.0858C7.13234 13.4408 7.56284 13.4408 7.90365 13.0991L8.28481 12.7219C8.63459 12.3713 8.62562 11.9674 8.26688 11.6124L4.67942 8.05749C4.31619 7.70245 3.90363 7.69801 3.54937 8.04418L3.17269 8.41698C2.82739 8.75871 2.82739 9.18032 3.18614 9.53536L4.2265 10.565C3.60318 10.9555 2.43277 11.4659 1.90362 11.9896C1.19062 12.6953 1.19958 13.6228 1.92604 14.3373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58803 11.1484C9.9357 11.493 10.4818 11.5353 10.8783 11.2483L14.0268 8.96962C14.8406 8.1642 14.8196 7.20603 13.9917 6.3659L13.5918 5.96319C12.8622 6.88664 10.7856 7.99062 10.3927 7.6018C10.3295 7.53931 10.3225 7.41433 10.4137 7.31712C11.2486 6.49088 11.8169 5.66463 11.9431 4.34541L9.081 1.50646C8.35137 0.791305 7.13766 1.06903 6.80091 2.36048C6.43499 3.7597 5.98912 5.32882 5.63468 6.31953C5.49259 6.71669 5.57478 7.17009 5.87434 7.46704L9.58803 11.1484Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCustomTheme);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-custom-theme.810b8db279a774393a5a4e8cbaf83914.svg";